<div #header class="title" *ngIf="header" (resize)="render()">
  <div><ng-content select="[header]"></ng-content></div>
  <div><ng-content select="[right]"></ng-content></div>
</div>
<div class="body">
  <ng-content></ng-content>
</div>
